const Banner = '/assets/cormarbus/new/banner.png';
const OriginIcon = '/assets/cormarbus/new/origin.svg';
// const DestinationIcon = '/assets/cormarbus/new/Cormar-Website-SearchBar-Destination.svg';
const DestinationIcon = '/assets/cormarbus/new/destination.svg';
const pin = '/assets/cormarbus/home/destination.svg';
const CalendarIcon = '/assets/cormarbus/new/calendar.svg';
const BookingActive = '/assets/cormarbus/new/buyticket-active.svg';
const BookingInActive = '/assets/cormarbus/new/buyticket-active.svg';
const CancelActive = '/assets/cormarbus/new/cancel-active.svg';
const CancelInActive = '/assets/cormarbus/new/cancel-inactive.svg';
const ChangeActive = '/assets/cormarbus/new/change-active.svg';
const ChangeInActive =
	'/assets/cormarbus/new/change-inactive.svg';

const checkboxIcon = '/static/images/icons/BusOperatorsWebsite-Checkbox.png';
const HeaderLogo = '/assets/cormarbus/home/cormarbus-logo.svg';
const FooterLogo = '/assets/cormarbus/home/cormarbus-logo-white.png';
const animation = '/static/images/animations/Services-kupos-PasajeBus-Orange.gif';
const pnr = '/assets/cormarbus/home/find-my-pnr.svg';

// Icons Section
const ist = '/assets/cormarbus/new/icon-one.png';
const second = '/assets/cormarbus/new/icon-two.png';
const third = '/assets/cormarbus/new/icon-three.png';
const office = '/assets/cormarbus/new/home.svg';
const HeadPhone = '/assets/cormarbus/new/phone.svg';
const PopupIcon = '/assets/cormarbus/home/popup.jpg';
const close = '/assets/cormarbus/icons/close.svg';
const close2 = '/assets/cormarbus/icons/close-icon-2.svg';

const success = '/assets/bahia/Blue/MyAccount-IllustratedIcons-CheckMark-Blue.svg';
const failure = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Information-Blue.svg';

const tick = '/assets/bahia/Blue/MyAccount-IllustratedIcons-Tick-Blue.svg';
const heartOn = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOn-Blue.svg';
const heartOff = '/assets/bahia/Blue/MyAccount-IllustratedIcons-HeartOff-Blue.svg';
const downArrow = '/assets/bahia/Blue/MyAccount-IllustratedIcons-DropDown-Blue.svg';
const registrationSuccess = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RightDocument-Blue.svg';
const userIcon = '/assets/bahia/Home/user_red_dot-BahiaAzul.svg';
const trips = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyTrips-Blue.svg';
const cards = '/assets/bahia/Blue/MyAccount-IllustratedIcons-MyCards-Blue.svg';
const wallet = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RechargeWallet-Blue.svg';
const transaction = '/assets/bahia/Blue/MyAccount-IllustratedIcons-ShareMoney-Blue.svg';

const otp = '/assets/bahia/Blue/MyAccount-IllustratedIcons-RestorePassword-Blue.svg';
const operatorPay = '/static/images/cormarpay-logo.jpg';

const petseatref = '/assets/traveltur/pet/Traveltur-ResultPage-SeatPick-PetsOnBoard_Pet Paw Icon (Reference).png';
const petseatModal = '/assets/cormarbus/popup-petseat.png';
const petfilteroff = '/assets/traveltur/pet/PetsOnBoard-Button-Filter_Off.png';
const petfilteron = '/static/images/seats/On-Button-Filter.svg';

const cormarbusIcons = [
	{ icon: downArrow, name: 'downArrow' },
	{ icon: userIcon, name: 'userIcon' },
	{ icon: trips, name: 'trips' },
	{ icon: cards, name: 'cards' },
	{ icon: wallet, name: 'wallet' },
	{ icon: transaction, name: 'transaction' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: tick, name: 'tick' },
	{ icon: heartOn, name: 'heartOn' },
	{ icon: heartOff, name: 'heartOff' },
	{ icon: registrationSuccess, name: 'registrationSuccess' },
	{ icon: otp, name: 'otp' },

	{ icon: HeaderLogo, name: 'headerLogo' },
	{ icon: FooterLogo, name: 'footerLogo' },
	{ icon: Banner, name: 'Banner' },
	{ icon: OriginIcon, name: 'Origin' },
	{ icon: DestinationIcon, name: 'Destination' },
	{ icon: success, name: 'success' },
	{ icon: failure, name: 'failure' },
	{ icon: pin, name: 'pin' },
	{ icon: CalendarIcon, name: 'Calendar' },
	{ icon: BookingInActive, name: 'BIA' },
	{ icon: BookingActive, name: 'BA' },
	{ icon: CancelInActive, name: 'CIA' },
	{ icon: CancelActive, name: 'CA' },
	{ icon: ChangeInActive, name: 'CTIA' },
	{ icon: ChangeActive, name: 'CTA' },
	{ icon: animation, name: 'animation' },
	{ icon: checkboxIcon, name: 'Checkbox' },
	{ icon: office, name: 'office' },
	{ icon: HeadPhone, name: 'Headphone' },
	{ icon: pnr, name: 'pnr' },

	// Icons Section
	{ icon: ist, name: 'ist' },
	{ icon: second, name: 'second' },
	{ icon: third, name: 'third' },
	{ icon: PopupIcon, name: 'Popup' },
	{ icon: close, name: 'close' },
	{ icon: close2, name: 'close2' },

	{ icon: operatorPay, name: 'operatorPay' },

	{ icon: petseatref, name: 'petseatref' },
	{ icon: petseatModal, name: 'petseatModal' },
	{ icon: petfilteron, name: 'petfilteron' },
	{ icon: petfilteroff, name: 'petfilteroff' },
];

export default cormarbusIcons;



// WEBPACK FOOTER //
// ./src/features/themes/functions/getIcons/cormarbusIcons.js